import { render } from "./iehcontrol.vue?vue&type=template&id=5a2810a8"
import script from "./iehcontrol.vue?vue&type=script&lang=js"
export * from "./iehcontrol.vue?vue&type=script&lang=js"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__